module.exports = {
  addtocart: '加入购物车',
  productinfo: '商品信息',
  product: '商品',
  productname: '    品名',
  cont: '数量   ',
  myinfo: '我的',
  sellcount: '月售',
  qtys: '份',
  ticket: '单',
  minPrice: '起送价',
  minutedelivery: '分钟送达',
  offer: '个',
  discountinformation: '优惠信息',
  merchantannouncement: '商家公告',
  deliveryprice: '商家配送',
  deliverytime: '平均配送时间',
  bulletin: '公告与活动',
  pics: '商家实景',
  info: '商家信息',
  favorite: '收藏',
  favorited: '已收藏',
  rating: '好评率',
  pay: '去结算',
  deliveryfee: '另需配送费',
  cart: '购物车',
  empty: '清空',
  total: '总额',
  completeorder: '完成点餐',
  orderid: '取餐号',
  amounts: '应付金额',
  ordersheet: '订单编号',
  backtomain: '返回界面',
  back: '返回',
  notsignin: '未登录',
  signin: '登录',
  signout: '注销',
  register: '注册',
  username: '用户名',
  password: '密码',
  captcha: '验证码',
  dsid: '代号',
  name: '姓名',
  phone: '电话',
  address: '地址',
  zip: '邮编',
  city: '城市',
  province: '省份',
  pending: '待收货',
  received: '已收货',
  complete: '完成',
  myaddress: '我的地址',
  customerservice: '客服电话',
  onlineservice: '在线客服',
  lessminprice: '还差',
  todelivery: '起送',
  language: '当前语言',
  confirmorder: '确认单据',
  paymode: '付款方式',
  paymodearray: '到付刷卡 | 到付现金 | 自 提',
  remark: '备注',
  sumbitorder: '提交    订单',
  ordererror: '发送订单错误 | Dirección incompleta! | por favor login',
  delivery: '运费',
  subtotal: '金额',
  newuser: '新用户',
  loginerror: '请输入用户名 | 请输入密码 | 请输入验证码 | 登录失败 | 注册失败 | 两次密码不对 | 用户名已存在 | 修改资料失败',
  loginerror0: '请输入用户名',
  loginerror1: '请输入密码',
  loginerror2: '请输入验证码',
  loginerror3: '登录失败',
  loginerror4: '注册失败',
  loginerror5: '两次密码不对',
  loginerror6: '用户名已存在',
  loginerror7: '修改资料失败',
  mydescription: '我的资料',
  description: '昵称',
  password2: '确认密码(不改则留空)',
  newusertips: '用户名已存在，请重新输入 | 恭喜你输入的用户名可以使用',
  completemydirecion: '请打开地址功能,填写有效的地址',
  prompt: '提示'
}



// WEBPACK FOOTER //
// ./src/i18n/cn.js